module.exports = __webpack_public_path__ + "static/media/sky247.75a12fe3.png";